// The frozen public ruleset identity (FROZEN, docs/设计文档/07 §1.2):
// every session message that carries a ruleset must match this triple
// exactly. The client must refuse unknown or mismatched identities and must
// never substitute a directory slug, a Git SHA, a model digest, all-zero
// digests, or any local default for the C++-returned identity
// (apps/web/README.md interface constraints).

export const RULESET_ID = "mutago.collapse-go";
export const SEMANTIC_VERSION = "0.1.0-draft";
export const DESCRIPTOR_SHA256 =
  "a21c67d7962b71a3a53b895de824dc6312502362de5341103c0265c2c81d0899";

export interface RulesetTriple {
  rulesetId: string;
  semanticVersion: string;
  descriptorSha256: string;
}

export const PUBLIC_RULESET: RulesetTriple = Object.freeze({
  rulesetId: RULESET_ID,
  semanticVersion: SEMANTIC_VERSION,
  descriptorSha256: DESCRIPTOR_SHA256,
});

// Exact match on all three fields; anything else is a mismatch the client
// must surface (never silently proceed).
export function rulesetMatches(value: unknown): value is RulesetTriple {
  if (typeof value !== "object" || value === null) return false;
  const v = value as Record<string, unknown>;
  return (
    v["rulesetId"] === RULESET_ID &&
    v["semanticVersion"] === SEMANTIC_VERSION &&
    v["descriptorSha256"] === DESCRIPTOR_SHA256
  );
}
